// extracted by mini-css-extract-plugin
export default {"container":"ScreenshotCard_container__-JeAM","screenshot-container":"ScreenshotCard_screenshot-container__rHyPS","info-container":"ScreenshotCard_info-container__rJpWA"};